import React from "react";
import { useFormik } from "formik";
import FormButtons from "../../../Molecule/Buttons/FormButtons";
import { CustomModal } from "../../../Atom/Modals";

const TableModal = ({ tableModal, setTableModal, createTable }) => {
	const formik = useFormik({
		initialValues: {
			rows: null,
			cols: null
		},
		validate: values => {
			const errors = {};
			if (values.rows !== null && values.rows <= 0)
				errors.rows = "Please add at-leaset one row";
			if (values.cols !== null && values.cols <= 0)
				errors.cols = "Please add at-leaset one column";
			if (values.rows !== null && values.rows > 30)
				errors.rows = "Maximum rows allowed is 30";
			if (values.cols !== null && values.cols > 10)
				errors.cols = "Maximum columns allowed is 10";
			return errors;
		},
		onSubmit: values => {
			createTable(values.rows, values.cols);
			setTableModal(false);
		},
		enableReinitialize: true
	});

	const onCloseModal = openModal => {
		setTableModal(openModal);
	};

	return (
		<div>
			<CustomModal
				width="50%"
				overflow="scroll"
				openModal={tableModal}
				setOpenModal={onCloseModal}
				header={"Add Table"}
				content={
					<>
						<div className="row px-3">
							<div className="col-12 col-md-6 col-lg-6 mb-3">
								<label className="label" htmlFor="rows">
									No. of Rows<span className="text-danger"> *</span>
								</label>
								<div className="">
									<input
										type="number"
										className={
											formik.errors["rows"] && formik.touched.rows
												? "input border-danger box-shawdow-none"
												: "input"
										}
										onBlur={formik.handleBlur}
										id="rows"
										placeholder="Enter No. of rows"
										value={formik.values.rows}
										onChange={e =>
											formik.setFieldValue("rows", Number(e.target.value))
										}
									/>
								</div>
								{formik.errors["rows"] && formik.touched.rows && (
									<p className="text-danger pt-1">{formik.errors.rows}</p>
								)}
							</div>
							<div className="col-12 col-md-6 col-lg-6 mb-3">
								<label className="label" htmlFor="cols">
									No. of Columns<span className="text-danger"> *</span>
								</label>
								<div className="">
									<input
										type="number"
										className={
											formik.errors["cols"] && formik.touched.cols
												? "input border-danger box-shawdow-none"
												: "input"
										}
										onBlur={formik.handleBlur}
										id="cols"
										placeholder="Enter No. of cols"
										value={formik.values.cols}
										onChange={e =>
											formik.setFieldValue("cols", Number(e.target.value))
										}
									/>
								</div>
								{formik.errors["cols"] && formik.touched.cols && (
									<p className="text-danger pt-1">{formik.errors.cols}</p>
								)}
							</div>
						</div>
						<FormButtons
							saveBtnContent={"Add"}
							saveBtnDisabled={!formik.dirty}
							cancelBtnContent="Close"
							onSave={() => formik.submitForm()}
							onCancel={() => onCloseModal(false)}
						/>
					</>
				}
			/>
		</div>
	);
};

export default TableModal;
